'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Link from '@Pure/Link'

const { app } = window;

export default class ECAdminExchangePage extends Component
{
	state = { loading: true };

	componentWillMount ()
	{
		app.resetFunctions();
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		qwest.post('/fetch/EC-exchange-documents').then(function (xhr, response)
		{
			const documents = response.documents || [];
			const budget = response.budget_range || 'none';

			if (budget !== 'none')
			{
				documents.unshift(
				{
					url: '/documents/2027_Grille_cotisations_CSE.pdf',
					filename: 'BASES TARIFAIRES ADHESION 2027 CSE DE + 50 salariés (ETP)',
					type: 'application/pdf',
					field_name: 'budget_pdf'
				});
			}

			component.setState(
			{
				documents: documents,
				budget_range: budget,
				loading: false,

				warning: documents.length === 0
				? 'Aucun document n\'a encore été mis à votre disposition.'
				: undefined
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState({ error: response?.error });
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let pdf_files = (state.documents || [])
		.map(function (file, i)
		{
			let output =
			(
				<div className="c-dashboard__row">
					<div className="c-dashboard__cell">
						<Link href={ file.url } type="application/pdf" target="_blank"
							className="u-full-width u-padding-top-10 u-padding-bottom-10
								u-padding-left-15 u-padding-right-15">
							{ file.filename }
						</Link>
					</div>
				</div>
			);

			return output;
		});

		const files_list = pdf_files.length > 0 ?
		(
			<>
				<div className="c-dashboard c-dashboard--head">
					<div className="c-dashboard__row">
						<div className="c-dashboard__cell">
							Documents
						</div>
					</div>
				</div>

				<div className="c-dashboard">
					{ pdf_files }
				</div>
			</>
		)
		: undefined;

		const status_list = getFormStatus(state);

		let output =
		(
			<Layout history={ props.history } page_title="Mes documents Synergies">

				<div className="page-content">

					<HolidaysMessage />

					{ files_list }

					{
						!files_list || status_list.length > 0 ?
						(
							<div className="page-txt">

								{ status_list }

							</div>
						)
						: undefined
					}

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}